import { HelmTypes, PolymerTypes } from '../helm/consts';
export class MonomerWorks {
    //private molfileConverter: IMolfileConverter;
    constructor(monomerLib /*, molfileConverter: IMolfileConverter*/) {
        this.monomerLib = monomerLib;
        //this.molfileConverter = molfileConverter;
    }
    //types according to Monomer possible
    getCappedRotatedMonomer(monomerType, monomerName) {
        // TODO: Check type of monomerType arg
        const monomer = this.monomerLib.getMonomer(monomerType, monomerName);
        if (monomer)
            return monomer.molfile; //TODO cap
        return null;
    }
}
export function helmTypeToPolymerType(helmType) {
    let polymerType = undefined;
    switch (helmType) {
        case HelmTypes.BASE:
        case HelmTypes.SUGAR: // r - ribose, d - deoxyribose
        case HelmTypes.LINKER: // p - phosphate
        case HelmTypes.NUCLEOTIDE:
        // @ts-ignore
        case 'nucleotide':
            polymerType = PolymerTypes.RNA;
            break;
        case HelmTypes.AA:
            polymerType = PolymerTypes.PEPTIDE;
            break;
        case HelmTypes.CHEM:
            polymerType = PolymerTypes.CHEM;
            break;
        case HelmTypes.BLOB:
            polymerType = PolymerTypes.BLOB;
            break;
        default:
            polymerType = PolymerTypes.PEPTIDE;
            console.warn(`Unexpected HelmType '${helmType}'`);
    }
    return polymerType;
}
//# sourceMappingURL=monomer-works.js.map